import { ZipCodeResult } from '../interfaces/interface.zipCode';
import { jsonIf } from '../utils/utils.network';

export const fetchZipCode = async (zipCode): Promise<ZipCodeResult> => {
  return fetch(`${process.env.EDGE_URL}/${process.env.V_PREFIX}/postal-code/${zipCode}?api_key=${process.env.API_KEY}`, {
    headers: {
      Authorization: `Basic ${process.env.ICO_TOKEN}`,
      QuestionConversion: 'fury',
      Date: new Date().toUTCString(),
    },
    method: 'GET',
    mode: 'cors',
    redirect: 'follow',
  })
    .then((res) => jsonIf(res))
    .then((res) => {
      return res.data;
    });
};
